export default "__VITE_ASSET__Bof6Kw4q__"